(function () {
'use strict';
'use strict';
const R = document.getElementById('beatlab');
const $ = s => R.querySelector(s), $$ = s => [...R.querySelectorAll(s)];
const hidden = () => { const v = R.closest('.hv'); return !R.offsetParent || (v && !v.classList.contains('on')); };
const SAVE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v12m0 0 4-4m-4 4-4-4M4 19h16"/></svg>';
const SPKR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 9.5v5h3.5L12 18V6L7.5 9.5H4z"/><path d="M15.5 9.8a3 3 0 0 1 0 4.4"/></svg>';
const MUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 9.5v5h3.5L12 18V6L7.5 9.5H4z"/><path d="m15.5 10 4 4m0-4-4 4"/></svg>';
const DICE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18"/><circle cx="8" cy="8" r="1.3" fill="currentColor"/><circle cx="16" cy="16" r="1.3" fill="currentColor"/><circle cx="12" cy="12" r="1.3" fill="currentColor"/></svg>';
const BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h10a5.5 5.5 0 0 1 0 11H8"/><path d="m8 4-4 4 4 4"/></svg>';
const FWD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 8H10a5.5 5.5 0 0 0 0 11h6"/><path d="m16 4 4 4-4 4"/></svg>';
$('#undo').innerHTML = BACK; $('#redo').innerHTML = FWD;
$('#rndSounds').innerHTML = DICE + 'New kit'; $('#rndBeat').innerHTML = DICE + 'New beat'; $('#midi').innerHTML = SAVE + 'Save MIDI';
const SITE = 'https://montybeats.com/';

/* ================================================================ colour: the vault year colours */
const COLOURS = [['Red', '#ba3e29'], ['Blue', '#2f44b7'], ['Green', '#29bc85'], ['Purple', '#8239b7'], ['Lime', '#afb700'], ['Rose', '#d6527a']];
let ACC = '#ba3e29', ARGB = '186,62,41';
function setColour(hex) {
  ACC = hex; ARGB = [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16)).join(',');
  R.style.setProperty('--accent', hex); R.style.setProperty('--rgb', ARGB);
  document.documentElement.style.setProperty('--accent', hex);   // the swatch is the whole page's colour
  document.documentElement.style.setProperty('--rgb', ARGB);   // the whole page follows the swatch
  $$('#sw button').forEach(b => b.classList.toggle('on', b.dataset.c === hex));
  try { localStorage.setItem('beatlab-colour', hex); } catch (e) {}
}
$('#sw').innerHTML = COLOURS.map(([n, c]) => `<button data-c="${c}" style="--c:${c}" title="${n}" aria-label="${n}"></button>`).join('');
try { setColour(localStorage.getItem('beatlab-colour') || ACC); } catch (e) { setColour(ACC); }

/* ================================================================ library */
const PV = 'https://pub-a26ec21b53f94d92a6247b9ca29bfb49.r2.dev', MASK = new TextEncoder().encode('montybeats-previews');
const MN = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const MONTHS = []; for (let y = 2021; y <= 2026; y++) for (let m = 1; m <= 12; m++) { const s = `${y}-${String(m).padStart(2, '0')}`; if (s >= '2021-06' && s <= '2026-09') MONTHS.push(s); }
const FIRST = '2023-06';   // this pack loads first so the page is playable at once, the other 63 follow
const label = m => MN[+m.slice(5)] + ' ' + m.slice(0, 4);
/* The current month has no vault product yet (it is this month's Lab release), so its product page
   404s. On the site MB_PACK_URL knows which months are locked and sends those to the subscribe
   section instead; standalone, the product page is the best guess we have. */
const packUrl = m => window.MB_PACK_URL ? window.MB_PACK_URL(m) : SITE + 'products/vault-' + m;
const NOTES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
const IDX = {}; const PREV_PV = window.MB_PV;   // the site's pack windows use MB_PV too: take it, pass it on
window.MB_PV = (m, d) => { IDX[m] = d; if (PREV_PV) PREV_PV(m, d); };
const loadIdx = m => new Promise(res => { const s = document.createElement('script'); s.src = `${PV}/previews/${m}/index.js`; s.onload = s.onerror = () => res(); document.head.appendChild(s); });
const bpmOf = n => { const a = [...n.matchAll(/\b(\d{2,3})\b/g)].map(x => +x[1]).filter(x => x >= 60 && x <= 200); return a.length ? a[a.length - 1] : null; };
// '#' isn't a word character, so \b after it never matched and every D# was read as D. (?![\w#]) ends the key properly.
const keyOf = n => { const m = n.match(/\b\d{2,3}\s+([A-G]#?)(?:m|min|maj|minor|major)?(?![\w#])/i) || n.match(/\b([A-G]#?)(?:m|min|maj|minor|major)?\s+\d{2,3}\b/i); return m ? NOTES.indexOf(m[1].toUpperCase()) : null; };   // key after the bpm or before it; 'Emin' and 'Fm' count as E and F
// a fill, a roll or a break is several hits in one file: fine as a loop, wrong on a drum row
const MULTI = /\b(fills?|rolls?|rolling|rollers?|breaks?|loops?|grooves?|beats?|bars?|combos?|flams?|stacks?|shuffles?|patterns?)\b/i;
function kindOf(p) {
  const dir = p.f.slice(0, p.f.lastIndexOf('/')), n = p.n, bpm = bpmOf(n);
  if (dir.startsWith('Drums/') && !bpm && !MULTI.test(n)) {
    // Hat is closed hats and nothing else. Everything that rings, open hats, rides, crashes, is Cymbals.
    if (/\b(rides?|crash(es)?|cymbals?|splash|china|gongs?)\b/i.test(n)) return 'Cymbals';
    if (/\bhats?\b/i.test(n)) return /\bopen\b/i.test(n) ? 'Cymbals' : 'Hat';
    const k = /\bkicks?\b/i.exec(n), s = /\bsnares?\b/i.exec(n);
    if (k && (!s || k.index < s.index)) return 'Kick';
    return s ? 'Snare' : null;
  }
  if (dir === 'Atmos') return 'Atmos';        // with a tempo it locks to the beat, without one it floats free
  if (dir === 'FX' && !bpm) return 'FX';
  if (!bpm) return null;
  if (dir === 'Bass') return 'Bass';
  if (dir === 'Synths') return 'Synths';
  if (dir === 'Pads') return 'Pads';
  if (dir === 'Drums/Hats & Percussion' && !/\b(fills?|rolls?|breaks?|drums)\b/i.test(n)) return 'Tops';
  return null;
}
const LIB = [], SND = {};
function addPack(m) { (IDX[m] ? IDX[m].banks.flatMap(b => b.pads) : []).forEach(p => { const k = kindOf(p); if (!k) return; const id = m + '|' + p.f; if (SND[id]) return;
  LIB.push(SND[id] = { id, m, f: p.f, n: p.n, p: p.p || [], k, bpm: bpmOf(p.n), key: keyOf(p.n) }); }); }
const pool = (k, f) => { const c = POOL_OF[k] || k; return LIB.filter(s => s.k === c && !s.multi && (!f || f(s))); };
const pick = a => a[Math.random() * a.length | 0];
/* Straight random repeats itself long before it has shown you the library, so each row remembers
   its last ten and skips them while it still has somewhere else to go. */
const RECENT = {};
function pickNew(k, a) {
  if (!a.length) return null;
  const r = RECENT[k] || (RECENT[k] = []), fresh = a.filter(s => !r.includes(s.id));
  const s = pick(fresh.length ? fresh : a);
  r.push(s.id); if (r.length > 10) r.shift();
  return s;
}

/* ================================================================ loading: decoded before the first tap, levelled */
const DEC = new OfflineAudioContext(2, 1, 44100);
/* How loud each thing should end up. One-shots are levelled by the loudness of the HIT (the part
   above a twentieth of their own peak, so silence and tails do not count), then ceilinged so nothing
   clips: two hats with the same body now land in the same place whatever their spikes look like.
   Loops are levelled by average loudness over the whole file. */
const LEVEL = { Kick: .26, Snare: .21, Hat: .095, 'Cymbals': .09, Bass: .8, Synths: .38, Pads: .34, Atmos: .28, Tops: .36, FX: .2 };
const CEIL = { Kick: .99, Snare: .99, Hat: .8, 'Cymbals': .8, FX: .9 };
const BUF = {};
function load(s) {
  if (!s) return Promise.resolve(null);
  return BUF[s.id] = BUF[s.id] || (async () => {
    const r = await fetch(`${PV}/previews/${s.m}/${s.f.split('/').map(encodeURIComponent).join('/')}`), b = new Uint8Array(await r.arrayBuffer());
    for (let i = 0; i < b.length; i++) b[i] ^= MASK[i % MASK.length];
    const buf = await DEC.decodeAudioData(b.buffer), d = buf.getChannelData(0);
    let peak = 0, sum = 0; for (let i = 0; i < d.length; i++) { const v = Math.abs(d[i]); if (v > peak) peak = v; sum += d[i] * d[i]; }
    const rms = Math.sqrt(sum / d.length) || 1e-4, loop = !!s.bpm || s.k === 'Atmos';
    let hs = 0, hn = 0; const gate = peak * .05;
    for (let i = 0; i < d.length; i++) if (Math.abs(d[i]) > gate) { hs += d[i] * d[i]; hn++; }
    const hit = Math.sqrt(hs / (hn || 1)) || 1e-4;
    s.gain = loop ? LEVEL[s.k] * Math.min(1 / peak, .22 / rms)
                  : Math.min(LEVEL[s.k] / hit, (CEIL[s.k] || .9) / (peak || 1));
    s.hit = hit; s.peak = peak;
    if (!loop) {                                    // count the hits: more than a couple and it is a fill, not a one-shot
      const B = 441, nb = Math.floor(d.length / B), e = new Float32Array(nb);
      for (let b = 0; b < nb; b++) { let x = 0; for (let i = b * B; i < b * B + B; i++) x += d[i] * d[i]; e[b] = x / B; }
      let top = 0; for (let b = 0; b < nb; b++) if (e[b] > top) top = e[b];
      let n = 0; for (let b = 1; b < nb; b++) if (e[b] > top * .12 && e[b - 1] < top * .04) n++;
      s.multi = n > 2;
      if (s.multi) ROWS.forEach(r => { if (S.drums[r].id === s.id) { const alt = pick(pool(r)); if (alt) { S.drums[r].id = alt.id; load(alt); draw(); } } });
    }
    s.dur = buf.duration;
    if (s.bpm) s.bars = [4, 2, 1].find(x => x <= buf.duration * s.bpm / 240 + .06) || 1;
    return buf;
  })().catch(() => { delete BUF[s.id]; return null; });
}

/* ================================================================ song */
const ROWS = ['Kick', 'Snare', 'Ghost', 'Hat', 'Cymbals'], LOOPS = ['Bass', 'Synths', 'Pads', 'Atmos', 'Tops'];
const POOL_OF = { Ghost: 'Snare' };   // the ghost row is a second, quieter snare: dnb shuffle, garage off-beats
// [step, velocity]. Ghost snares and accented hats are what stop a pattern sounding like a robot.
/* Steps are 0-15 here, 1-16 in the sources. What the books say, and what these are:
     two step   kick 1 + 11, snare 5 + 13                          the everyday dnb groove
     amen       kick 1,3,11,12, snare 5,8,10,13,16                 first bar of the break, 8,10,16 are ghosts
     halftime   snare on beat 3 alone, kick on 1, the rest is space
     uk garage  kick 1,7,10, snare 5 + 13, open hat on every offbeat, 55-65% swing
   The last number is swing: .5 is straight, .61 pushes every off 16th most of the way to the shuffle. */
const STYLES = [
  ['Classic', 174, { Kick: [[0, 1], [10, .92]], Snare: [[4, 1], [12, 1]], Ghost: [[7, .3], [15, .34]],
    Hat: [[0, .45], [2, .9], [4, .5], [6, .85], [8, .45], [10, .9], [12, .5], [14, .8]], 'Cymbals': [] }, .5],
  ['Two step', 174, { Kick: [[0, 1], [7, .9]], Snare: [[4, 1], [12, 1]], Ghost: [],
    Hat: [[2, .85], [6, .6], [10, .85], [14, .6]], 'Cymbals': [] }, .5],
  ['Amen-ish', 174, { Kick: [[0, 1], [2, .78], [10, 1], [11, .62]], Snare: [[4, 1], [12, 1]], Ghost: [[7, .42], [9, .5], [15, .36]],
    Hat: [[0, .9], [2, .55], [4, .8], [6, .5], [8, .9], [10, .55], [12, .8], [14, .5]], 'Cymbals': [] }, .5],
  // boom bap at 87, which is exactly half of 174, so every 174 loop in the packs plays over it at
  // its own speed and its own pitch, twice a bar. Kick on 1 and either side of 3, snare on 2 and 4.
  ['Boom bap', 87, { Kick: [[0, 1], [6, .82], [10, .92]], Snare: [[4, 1], [12, 1]], Ghost: [[7, .3], [14, .26]],
    Hat: [[0, .85], [2, .45], [4, .8], [6, .45], [8, .85], [10, .45], [12, .8], [14, .45]], 'Cymbals': [] }, .55],
  ['Halftime', 174, { Kick: [[0, 1], [6, .8], [11, .85]], Snare: [[8, 1]], Ghost: [[3, .3], [14, .34]],
    Hat: [[0, .7], [3, .45], [6, .7], [11, .5], [14, .6]], 'Cymbals': [[12, .55]] }, .5],
  ['140', 140, { Kick: [[0, 1], [3, .75], [10, .9]], Snare: [[8, 1]], Ghost: [[12, .3]],
    Hat: [[2, .8], [6, .6], [10, .8], [14, .6]], 'Cymbals': [] }, .53],
  // the offbeats are an accented closed hat, not an open one: an open hat on every offbeat shouts
  ['UK garage', 135, { Kick: [[0, 1], [6, .85], [9, .8]], Snare: [[4, 1], [12, 1]], Ghost: [[7, .3], [11, .26], [15, .32]],
    Hat: [[1, .32], [2, .85], [3, .46], [5, .32], [6, .8], [7, .44], [9, .32], [10, .85], [11, .46], [13, .32], [14, .8], [15, .44]],
    'Cymbals': [] }, .61],
];
const FAM = { 'Classic': 'step', 'Two step': 'step', 'Amen-ish': 'amen', 'Boom bap': 'boom', 'Halftime': 'half', '140': 'half', 'UK garage': 'garage' };
const HALF = i => i >= 0 && (STYLES[i][0] === 'Halftime' || STYLES[i][0] === '140');
const S = { bpm: 174, style: 0, half: false, swing: .53, fam: 'step', key: null, drums: {}, loops: {} };
ROWS.forEach(r => S.drums[r] = { id: null, mute: false, vol: 1, steps: Array(16).fill(0) });
LOOPS.forEach(l => S.loops[l] = { s: null, on: false, mute: false, vol: 1, fresh: true, src: null, bus: null, an: null, hist: [], until: 0 });

function applyPattern(pat) { ROWS.forEach(r => { S.drums[r].steps = Array(16).fill(0); (pat[r] || []).forEach(([i, v]) => S.drums[r].steps[i] = v); }); }
function setStyle(i) {
  S.style = i; S.half = HALF(i); const [nm, bpm, pat, sw] = STYLES[i]; S.swing = sw; S.fam = FAM[nm]; applyPattern(pat); showSwing();
  if (bpm !== S.bpm) { S.bpm = bpm; S.key = null; LOOPS.forEach(pickLoop); prepareNext(); LOOPS.forEach(prepareOne); }
  draw(); push();
}
/* Randomize stays inside the groove you are in. The downbeat and the backbeat never move, and
   everything else is drawn from short lists of things that actually work in that style, so there
   is no such thing as a bad roll: only a different one. */
const KICKS = { step: [[3], [2], [13], [3, 13], [2, 11], [11], []], amen: [[2], [2, 11], [2, 3, 11], [11], [2, 13]],
  half: [[6], [3], [6, 11], [11], [3, 14], [3, 6, 11], [6, 13], [3, 10, 14], [11, 14]],
  boom: [[6, 10], [7, 10], [10], [6], [6, 11], [3, 10]],
  garage: [[6, 9], [6, 10], [9], [6], [6, 9, 14], [9, 13]] };
/* Everywhere else the backbeat is the one thing that never moves. Garage is the exception: the
   second clap skipping off beat 4 is the "2-step" in 2-step, so it gets a list of its own. */
const SNARES = { garage: [[4, 12], [4, 12], [4, 14], [4, 11], [4, 13], [4, 15]] };
const GHOSTS = { step: [[7], [15], [7, 15], [5, 6, 7], [13, 14, 15], [6, 7, 15]], amen: [[7, 9], [7, 9, 15], [9, 15], [2, 9]],
  half: [[3], [14], [3, 14], [11, 14], [5, 6], [10, 11], [3, 6, 14], [12, 14]],
  boom: [[7], [14], [7, 14], [11], []],
  garage: [[7], [7, 15], [11, 15], [7, 11, 15], [3, 7], [15]] };
// the accents land on 2, 6, 10 and 14 wherever they appear, which is the shuffle in garage and the
// backbone everywhere else, so every garage template has to carry those offbeats or it stops sounding like garage
const HATS = { step: [[2, 6, 10, 14], [0, 2, 4, 6, 8, 10, 12, 14], [0, 2, 3, 4, 6, 8, 10, 11, 12, 14], [2, 5, 6, 10, 13, 14]],
  amen: [[0, 2, 4, 6, 8, 10, 12, 14], [0, 2, 3, 4, 6, 8, 10, 12, 14], [2, 6, 10, 14]],
  half: [[0, 3, 6, 11, 14], [2, 6, 10, 14], [0, 4, 8, 12], [2, 3, 6, 10, 11, 14], [2, 6, 7, 10, 14, 15],
    [0, 2, 3, 6, 8, 10, 11, 14], [2, 5, 6, 10, 13, 14]],
  boom: [[0, 2, 4, 6, 8, 10, 12, 14], [0, 2, 3, 4, 6, 8, 10, 11, 12, 14], [2, 6, 10, 14]],
  garage: [[1, 2, 3, 5, 6, 7, 9, 10, 11, 13, 14, 15], [2, 3, 6, 7, 10, 11, 14, 15], [2, 6, 10, 14], [1, 2, 5, 6, 9, 10, 13, 14]] };
/* on screen: 0 is straight and 70 is about a triplet. underneath: .5 is straight, which is what the
   timing maths and the midi export both read. */
const SWING_SPAN = 400;
function showSwing() { const el = $('#swing'); if (!el) return; el.value = Math.round((S.swing - .5) * SWING_SPAN); $('#swingV').textContent = el.value + '%'; }
function randomBeat() {
  spin('#rndBeat');
  const f = S.fam || 'step', r = (a, b) => +(a + Math.random() * (b - a)).toFixed(2);
  const snare = f === 'half' ? [[8, 1]] : (SNARES[f] ? pick(SNARES[f]) : [4, 12]).map(i => [i, 1]);
  const kick = [[0, 1], ...pick(KICKS[f]).filter(i => !snare.some(x => x[0] === i)).map(i => [i, r(.62, .95)])];
  if (f === 'step' || f === 'amen') { if (!kick.some(k => k[0] === 10)) kick.push([10, r(.9, 1)]); }
  else if (f === 'boom' && !kick.some(k => k[0] === 10)) kick.push([10, r(.82, .95)]);
  const taken = i => kick.some(k => k[0] === i) || snare.some(k => k[0] === i);
  /* A run of ghosts at the same velocity is the most machine-like thing a drum machine does, so a
     run gets a shape: each one steps down from the last and the tail is the quietest note in the bar. */
  const gset = pick(GHOSTS[f]).filter(i => !taken(i));
  const ghost = gset.map((i, n) => {
    const run = n > 0 && i === gset[n - 1] + 1;
    return [i, run ? Math.max(.14, +(gset.length > 2 ? .38 - n * .09 : r(.18, .3)).toFixed(2)) : r(.24, .42)];
  });
  const oh = f === 'garage' ? [] : (Math.random() < .4 ? [[pick([6, 14]), r(.45, .68)]] : []);
  const hat = pick(HATS[f]).filter(i => !oh.some(o => o[0] === i)).map(i => [i, i % 4 === 2 ? r(.75, .95) : r(.32, .58)]);
  applyPattern({ Kick: kick, Snare: snare, Ghost: ghost, Hat: hat, 'Cymbals': oh });
  S.style = -1; draw(); push(); if (!playing) toggle();
}

/* ---------------- sounds: pick, and always have the next pick already loaded */
/* A kit that hangs together: kick and snare out of the same pack, the ghost a different snare and a
   softer one where the name says so, and the two hats never the same sample. */
const GHOSTY = /\b(rim|ghost|soft|tight|short|snap|light|thin|dry)\b/i;
function kitRoll() {
  const packs = MONTHS.filter(m => pool('Kick', s => s.m === m).length && pool('Snare', s => s.m === m).length), m = pick(packs);
  const snare = pickNew('Snare', pool('Snare', s => s.m === m)), rest = pool('Snare', s => s !== snare), soft = rest.filter(x => GHOSTY.test(x.n));
  const hat = pickNew('Hat', pool('Hat')) || pick(pool('Cymbals'));
  return { Kick: pickNew('Kick', pool('Kick', s => s.m === m)), Snare: snare, Ghost: pickNew('Ghost', soft.length ? soft : rest) || snare,
    Hat: hat, 'Cymbals': pickNew('Cymbals', pool('Cymbals', x => x !== hat)) || pick(pool('Hat', x => x !== hat)) || hat };
}
/* A loop fits at the song's tempo, or at double it. Double is what makes boom bap work: a 174 bass
   over 87 drums is the same music at half the pace, and because it runs at its own speed nothing is
   stretched or pitched. Atmos with no tempo always fit. */
function tempoMult(s) {
  if (!s.bpm) return s.k === 'Atmos' ? 1 : 0;
  for (const m of [1, 2]) if (Math.abs(s.bpm / (S.bpm * m) - 1) <= .05) return m;
  return 0;
}
const fits = s => !!tempoMult(s);
// Every pack, every time. The key is shown on the row but it does not narrow the roll: filtering
// to one key put synths at 24 of 219, which is why the dice kept handing back the same few.
function loopRoll(l, not) { return pickNew(l, pool(l, s => fits(s) && s !== not)); }
let NEXT = null;
function roll() { const kit = kitRoll(), bass = loopRoll('Bass'), R = { kit, key: bass && bass.key, loops: { Bass: bass } }; LOOPS.slice(1).forEach(l => R.loops[l] = loopRoll(l)); return R; }
function prepareNext() { if (!LIB.length) return; NEXT = roll(); [...Object.values(NEXT.kit), ...Object.values(NEXT.loops)].forEach(load); }
const NEXT_ONE = {};
function prepareOne(k) { NEXT_ONE[k] = ROWS.includes(k) ? pickNew(k, pool(k, s => s.id !== S.drums[k].id)) : loopRoll(k, S.loops[k].s); load(NEXT_ONE[k]); }
function applyRoll(R) { ROWS.forEach(r => { if (R.kit[r]) S.drums[r].id = R.kit[r].id; }); S.key = R.key; LOOPS.forEach(l => swap(l, R.loops[l])); ROWS.concat(LOOPS).forEach(prepareOne); }
// Only the drums. The bass, the music and the tops each have their own dice, so a new kit
// never pulls the track out from under you.
function newSounds() {
  spin('#rndSounds');
  const kit = (NEXT && NEXT.kit) || kitRoll();
  ROWS.forEach(r => { if (kit[r]) { S.drums[r].id = kit[r].id; load(kit[r]); } });
  ROWS.forEach(prepareOne); prepareNext(); draw(); push(); if (!playing) toggle();
}
function pickLoop(l) { swap(l, loopRoll(l, S.loops[l].s)); if (l === 'Bass' && S.loops.Bass.s) S.key = S.loops.Bass.s.key; }
function swap(l, s) { const L = S.loops[l]; if (L.src) try { L.src.stop(); } catch (e) {} L.src = null; L.s = s; L.fresh = true; L.until = 0; load(s); }
function spin(sel) { const b = $(sel); b.classList.remove('spin'); void b.offsetWidth; b.classList.add('spin'); }

/* ================================================================ audio */
let ac, master;
// mute and volume are the same knob: the channel's own gain node
const level = ch => { if (ch.bus) ch.bus.gain.value = ch.mute ? 0 : ch.vol; };
function boot() {
  ac = new (window.AudioContext || window.webkitAudioContext)();
  const lim = ac.createDynamicsCompressor(); lim.threshold.value = -8; lim.knee.value = 4; lim.ratio.value = 12; lim.attack.value = .003; lim.release.value = .12;
  master = ac.createGain(); master.gain.value = .8; master.connect(lim).connect(ac.destination);
  ROWS.forEach(r => { const D = S.drums[r]; D.bus = ac.createGain(); D.bus.connect(master); level(D); });
  LOOPS.forEach(l => { const L = S.loops[l]; L.bus = ac.createGain(); L.an = ac.createAnalyser(); L.an.fftSize = 1024; L.bus.connect(L.an); L.bus.connect(master); level(L); });
}
function play(s, t, bars, offBars, vel, bus, fade) {
  return load(s).then(buf => {
    if (!buf || s.multi || t < ac.currentTime - .05) return null;   // a loop that slipped onto a drum row never sounds, not even once
    const src = ac.createBufferSource(), g = ac.createGain(), level = s.gain * Math.pow(vel == null ? 1 : vel, 1.5);
    const rate = s.bpm ? S.bpm * (tempoMult(s) || 1) / s.bpm : 1;
    src.buffer = buf; src.playbackRate.value = rate;
    const bd = 240 / S.bpm, dur = bars ? bars * bd : buf.duration / rate;
    if (bars && dur > buf.duration / rate + .02) src.loop = true;   // a double-time loop goes round twice a bar
    if (fade) { g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(level, t + fade); g.gain.setValueAtTime(level, t + dur - fade); g.gain.linearRampToValueAtTime(0, t + dur); }
    else { g.gain.value = level; if (bars) { g.gain.setValueAtTime(level, t + dur - .012); g.gain.linearRampToValueAtTime(0, t + dur); } }
    src.connect(g).connect(bus || master); src.start(t, ((offBars || 0) * bd * rate) % (buf.duration || 1)); src.stop(t + dur + .02);
    return src;
  });
}
let playing = false, step = 0, bar = 0, nextT = 0, timer, curStep = -1;
function schedule() {
  const six = 60 / S.bpm / 4;
  while (nextT < ac.currentTime + .12) {
    if (step === 0) {
      LOOPS.forEach(l => { const L = S.loops[l]; if (!L.on || !L.s) return;
        if (!L.s.bpm) { if (nextT >= L.until && L.s.dur) { play(L.s, nextT, 0, 0, 1, L.bus, 1.2).then(src => { if (src) L.src = src; }); L.until = nextT + L.s.dur - 1.2; } return; }   // free atmos, crossfaded
        const n = Math.max(1, Math.round((L.s.bars || 1) / (tempoMult(L.s) || 1))), into = bar % n;
        if (into === 0 || L.fresh) { play(L.s, nextT, n - into, into, 1, L.bus).then(src => { if (src) L.src = src; }); L.fresh = false; } });
    }
    ROWS.forEach(r => { const D = S.drums[r], v = D.steps[step]; if (v && SND[D.id]) play(SND[D.id], nextT + groove(r, step, six), 0, 0, v, D.bus); });
    const st = step, t = nextT; setTimeout(() => { if (playing) { curStep = st; head(); } }, Math.max(0, (t - ac.currentTime) * 1000));
    nextT += six; if (++step === 16) { step = 0; bar++; }
  }
}
/* Swing pushes every off 16th late, which is the whole garage shuffle and a little of the dnb one.
   On top of that each hit gets a few milliseconds of slop, more on the quiet parts than on the kick
   and the backbeat, which have to stay where they are or the whole thing stops being a beat.
   Ghosts also sit a touch behind on purpose: that is what makes a played bar sound played. */
const SLOP = { Kick: .0015, Snare: .003, Ghost: .012, Hat: .006, 'Cymbals': .006 };
// feel() is the half that IS the pattern, so Save MIDI writes it into the file too; the slop on top
// is a different roll of the dice every bar and belongs to the performance, not to the notes.
function feel(r, i, six) { return (i % 2 ? (S.swing - .5) * 2 * six : 0) + (r === 'Ghost' ? .007 : 0); }
function groove(r, i, six) { return feel(r, i, six) + (Math.random() - .5) * 2 * (SLOP[r] || .004); }
function toggle() {
  if (!ac) return; if (ac.state === 'suspended') ac.resume();
  playing = !playing; $('#play').classList.toggle('on', playing);
  if (playing) { step = 0; bar = 0; LOOPS.forEach(l => { S.loops[l].fresh = true; S.loops[l].until = 0; }); nextT = ac.currentTime + .08; timer = setInterval(schedule, 25); }
  else { clearInterval(timer); LOOPS.forEach(l => { const L = S.loops[l]; if (L.src) try { L.src.stop(); } catch (e) {} }); curStep = -1; head(); }
}
function head() { $$('.st.ph').forEach(x => x.classList.remove('ph')); if (curStep >= 0) $$(`.st[data-s="${curStep}"]`).forEach(x => x.classList.add('ph')); }

/* ================================================================ loop ribbons */
const TD = new Float32Array(1024);
function ribbons() {
  if (hidden()) return requestAnimationFrame(ribbons);   // other tab: nothing to draw
  LOOPS.forEach(l => {
    const L = S.loops[l], cv = $(`.rib[data-l="${l}"] canvas`); if (!cv) return;
    const dpr = devicePixelRatio || 1, W = Math.round(cv.clientWidth * dpr), H = Math.round(cv.clientHeight * dpr);
    if (!W) return; if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
    const g = cv.getContext('2d'), bw = 4 * dpr, cols = Math.floor(W / bw), mid = H / 2, live = playing && L.on && L.an;
    g.clearRect(0, 0, W, H);
    if (live) {
      let lvl = 0; L.an.getFloatTimeDomainData(TD); for (let i = 0; i < TD.length; i++) lvl = Math.max(lvl, Math.abs(TD[i]));
      L.hist.push(Math.min(1, lvl * 1.6)); while (L.hist.length > cols) L.hist.shift();
      const grad = g.createLinearGradient(0, 0, W, 0); grad.addColorStop(0, `rgba(${ARGB},0)`); grad.addColorStop(.3, `rgba(${ARGB},.55)`); grad.addColorStop(1, ACC);
      g.fillStyle = grad; g.shadowColor = `rgba(${ARGB},.8)`; g.shadowBlur = 10 * dpr;
      L.hist.forEach((v, i) => { const x = W - (L.hist.length - i) * bw, h = Math.max(1.5 * dpr, v * (mid - 2 * dpr)); g.fillRect(x, mid - h, bw - 1.5 * dpr, h * 2); });
      g.shadowBlur = 0; g.fillStyle = '#ededea'; g.fillRect(W - 2 * dpr, mid - H * .42, 2 * dpr, H * .84);
    } else {
      L.hist.length = 0;
      const p = L.s ? L.s.p : [], n = p.length;
      g.fillStyle = L.on ? `rgba(${ARGB},.45)` : '#262624';
      for (let c = 0; c < cols; c++) { const v = n ? p[Math.floor(c / cols * n)] : .03, h = Math.max(dpr, v * (mid - 4 * dpr) * (L.on ? 1 : .8)); g.fillRect(c * bw, mid - h, bw - 1.5 * dpr, h * 2); }
    }
  });
  requestAnimationFrame(ribbons);
}
/* ================================================================ undo
   A step, a velocity, a mute, a kit, a loop, a preset: all of it is just state, so the history is
   whole snapshots rather than a list of edits. 60 of them, and nothing here ever pushes a snapshot
   while it is busy applying one. */
function snapshot() {
  return JSON.stringify({ d: ROWS.map(r => [S.drums[r].id, S.drums[r].mute, S.drums[r].steps, S.drums[r].vol]),
    l: LOOPS.map(l => [S.loops[l].s && S.loops[l].s.id, S.loops[l].on, S.loops[l].mute, S.loops[l].vol]),
    st: S.style, bpm: S.bpm, sw: S.swing, fam: S.fam, key: S.key });
}
let hist = [], hi = -1, restoring = false;
function push() { if (restoring) return; const snap = snapshot(); if (snap === hist[hi]) return;
  hist = hist.slice(0, hi + 1); hist.push(snap); if (hist.length > 60) hist.shift(); hi = hist.length - 1; marks(); }
function marks() { const u = $('#undo'), r = $('#redo'); if (!u) return; u.disabled = hi <= 0; r.disabled = hi >= hist.length - 1; }
function restore(n) {
  if (n < 0 || n >= hist.length) return;
  const was = playing; restoring = true; hi = n; const o = JSON.parse(hist[n]);
  S.bpm = o.bpm; S.swing = o.sw; showSwing(); S.fam = o.fam; S.key = o.key; S.style = o.st; S.half = HALF(o.st);
  ROWS.forEach((r, i) => { const [id, mute, steps, vol] = o.d[i], D = S.drums[r];
    D.id = id; D.mute = mute; D.vol = vol == null ? 1 : vol; D.steps = steps.slice(); level(D); if (SND[id]) load(SND[id]); });
  LOOPS.forEach((l, i) => { const [id, on, mute, vol] = o.l[i], L = S.loops[l];
    if ((L.s && L.s.id) !== id) swap(l, SND[id] || null);
    L.mute = !!mute; L.vol = vol == null ? 1 : vol; level(L);
    if (L.on !== on) { L.on = on; if (!on && L.src) try { L.src.stop(); } catch (e) {} L.fresh = true; L.until = 0; } });
  ROWS.concat(LOOPS).forEach(prepareOne); draw(); restoring = false; marks();
  if (was && !playing) toggle();
}

/* ================================================================ ui */
// 31 of the 2,738 sample names carry an & or an apostrophe today, and nothing stops one carrying a
// quote tomorrow. The theme's pack windows already escape; this is the same thing.
const esc = t => String(t == null ? '' : t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
const clean = (s, k) => s.n.replace(new RegExp('^(' + (POOL_OF[k] || k) + 's?|Hats?|Pads?|Synths?|Bass|Atmos)\\s+', 'i'), '').replace(/\s+\d{2,3}(\s+[A-G]#?)?$/, '');
const fader = (k, ch) => `<input class="vol" type="range" min="0" max="1.4" step=".02" value="${ch.vol}" data-vol="${k}" aria-label="${k} volume" title="Volume">`;
const packLink = s => s ? `<a href="${packUrl(s.m)}" target="_blank" rel="noopener" title="Get the ${label(s.m)} pack">${label(s.m)}</a>` : '';
function draw() {
  $('#styles').innerHTML = STYLES.map(([n], i) => `<button class="${S.style === i ? 'on' : ''}" data-style="${i}">${n}</button>`).join('');
  $('#drums').innerHTML = ROWS.map(r => { const D = S.drums[r], s = SND[D.id];
    return `<div class="row${D.mute ? ' off' : ''}" data-r="${r}" style="--d:${320 + ROWS.indexOf(r) * 90}"><div class="who"><div><b>${r}</b><span><span data-hear="${r}" style="display:inline" title="${esc(s && s.n)}">${s ? esc(clean(s, r)) : '…'}</span> · ${packLink(s)}</span>${fader(r, D)}</div><button class="mute${D.mute ? ' off' : ''}" data-mute="${r}" title="${D.mute ? 'Unmute' : 'Mute'} ${r.toLowerCase()}" aria-pressed="${D.mute}">${D.mute ? MUTED : SPKR}</button><button class="shuf" data-shuf="${r}" title="Try another ${r.toLowerCase()}">${DICE}</button></div>
      <div class="steps">${D.steps.map((v, i) => `<button class="st${v ? ' on' : ''}" data-s="${i}" style="--v:${v};--i:${i}" aria-label="${r} step ${i + 1}"></button>`).join('')}</div></div>`; }).join('');
  $('#loops').innerHTML = LOOPS.map(l => { const L = S.loops[l], s = L.s;
    return `<div class="rib${L.on ? ' on' : ''}${L.mute ? ' off' : ''}" data-l="${l}" style="--d:${760 + LOOPS.indexOf(l) * 80}" title="${L.on ? 'Tap to take it out' : 'Tap to bring it in'}"><div class="who"><div><b>${l}</b>
        <span title="${esc(s && s.n)}">${s ? esc(clean(s, l) + (s.key != null ? ' · ' + NOTES[s.key] : '')) : 'nothing at this tempo'}${s ? ' · ' + packLink(s) : ''}</span><div class="tag mono">${L.on ? 'Playing' : 'Tap to bring in'}</div>${fader(l, L)}</div>
        <button class="mute${L.mute ? ' off' : ''}" data-mute="${l}" title="${L.mute ? 'Unmute' : 'Mute'} ${l.toLowerCase()}" aria-pressed="${L.mute}">${L.mute ? MUTED : SPKR}</button><button class="shuf" data-shuf="${l}" title="Try another ${l.toLowerCase()} loop">${DICE}</button></div><canvas></canvas></div>`; }).join('');
  $('#info').textContent = `${S.bpm} BPM${packsLoaded < MONTHS.length ? ' · loading my packs' : ''}`;
  drawBuy(); head();
}
// every pack you can hear right now: drum rows with hits in them, loops that are in
function drawBuy() {
  const heard = [];
  ROWS.forEach(r => { const D = S.drums[r]; if (D.steps.some(v => v) && !D.mute && SND[D.id]) heard.push([SND[D.id].m, r]); });
  LOOPS.forEach(l => { const L = S.loops[l]; if (L.on && !L.mute && L.s) heard.push([L.s.m, l]); });
  const packs = {}; heard.forEach(([m, what]) => (packs[m] = packs[m] || []).push(what));
  const list = Object.keys(packs).sort().reverse();
  $('#buy').innerHTML = `<span class="t mono">In this beat</span>` + (list.length ? list.map(m => `<a href="${packUrl(m)}" target="_blank" rel="noopener" class="${packs[m].length > 1 ? 'hot' : ''}">${label(m)} <i>${packs[m].join(', ')}</i> <b>Get it →</b></a>`).join('') : '<span class="t">nothing yet, press play</span>');
}
let drag = null;
document.addEventListener('input', e => {
  if (e.target.id === 'swing') { S.swing = .5 + +e.target.value / SWING_SPAN; $('#swingV').textContent = e.target.value + '%'; return; }
  const v = e.target.closest('.vol'); if (!v) return;
  const ch = S.drums[v.dataset.vol] || S.loops[v.dataset.vol];
  ch.vol = +v.value; if (ch.mute) { ch.mute = false; v.closest('.who').querySelector('.mute').classList.remove('off'); }
  level(ch);
});
document.addEventListener('change', e => { if (e.target.closest('.vol')) push(); });
R.addEventListener('pointerdown', e => {
  const st = e.target.closest('.st'); if (!st) return; e.preventDefault();
  const r = st.closest('.row').dataset.r, i = +st.dataset.s; drag = { st, r, i, y: e.clientY, v0: S.drums[r].steps[i] || 1, moved: false }; st.setPointerCapture(e.pointerId);
});
document.addEventListener('pointermove', e => {
  if (!drag) return; const dy = drag.y - e.clientY; if (!drag.moved && Math.abs(dy) < 4) return;
  drag.moved = true; const v = Math.max(.1, Math.min(1, +(drag.v0 + dy / 90).toFixed(2))), D = S.drums[drag.r];
  D.steps[drag.i] = v; drag.st.classList.add('on'); drag.st.style.setProperty('--v', v);
  let tip = drag.st.querySelector('.vel'); if (!tip) { tip = document.createElement('span'); tip.className = 'vel'; drag.st.appendChild(tip); } tip.textContent = Math.round(v * 100) + '%';
});
document.addEventListener('pointerup', () => {
  if (!drag) return; const D = S.drums[drag.r];
  if (!drag.moved) { D.steps[drag.i] = D.steps[drag.i] ? 0 : 1; drag.st.classList.toggle('on', !!D.steps[drag.i]); drag.st.style.setProperty('--v', D.steps[drag.i]); }
  const tip = drag.st.querySelector('.vel'); if (tip) tip.remove();
  if (D.steps[drag.i] && !playing && ac) play(SND[D.id], ac.currentTime + .01, 0, 0, D.steps[drag.i], D.bus);
  if (S.style >= 0) { S.style = -1; $$('[data-style].on').forEach(b => b.classList.remove('on')); }
  drag = null; drawBuy(); push();
});
R.addEventListener('click', e => {
  if (e.target.closest('a') || e.target.closest('.vol')) return;   // pack links open the shop, faders are their own thing
  const t = e.target.closest('button,[data-hear],.rib'); if (!t || t.classList.contains('st')) return;
  if (t.dataset.c) return setColour(t.dataset.c);
  if (t.dataset.mute) { const ch = S.drums[t.dataset.mute] || S.loops[t.dataset.mute];
    ch.mute = !ch.mute; level(ch); draw(); push(); return; }
  if (t.id === 'play') return toggle();
  if (t.id === 'rndSounds') return newSounds();
  if (t.id === 'rndBeat') return randomBeat();
  if (t.id === 'midi') return saveMidi();
  if (t.id === 'undo') return restore(hi - 1);
  if (t.id === 'redo') return restore(hi + 1);
  if (t.dataset.style) { setStyle(+t.dataset.style); if (!playing) toggle(); return; }
  if (t.dataset.shuf) { const k = t.dataset.shuf, next = NEXT_ONE[k];
    if (ROWS.includes(k)) { const s = (next && !next.multi) ? next : pickNew(k, pool(k)); if (s) S.drums[k].id = s.id; }   // no audition: tap the name for that
    else { swap(k, next && fits(next) ? next : loopRoll(k, S.loops[k].s)); if (k === 'Bass' && S.loops.Bass.s) S.key = S.loops.Bass.s.key; S.loops[k].on = true; if (!playing) toggle(); }
    prepareOne(k); draw(); push(); return; }
  if (t.dataset.hear) { const D = S.drums[t.dataset.hear]; if (SND[D.id] && ac) play(SND[D.id], ac.currentTime + .01, 0, 0, 1, D.bus); return; }
  if (t.classList.contains('rib')) { const L = S.loops[t.dataset.l]; if (!L.s) return; L.on = !L.on; if (!L.on && L.src) try { L.src.stop(); } catch (e) {} L.fresh = true; L.until = 0; draw(); push(); if (L.on && !playing) toggle(); }
});
addEventListener('keydown', e => {
  if (hidden() || !seen) return;                                   // the other tab, or not scrolled to yet
  const t = e.target.tagName; if (t === 'INPUT' || t === 'TEXTAREA' || e.target.isContentEditable) return;
  if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'z') { e.preventDefault(); return restore(e.shiftKey ? hi + 1 : hi - 1); }
  if (e.key !== ' ' || e.metaKey || e.ctrlKey) return;
  const r = R.getBoundingClientRect(); if (r.bottom < 80 || r.top > innerHeight - 80) return;
  e.preventDefault(); toggle();
});
let seen = false;

/* ================================================================ save the pattern as MIDI (one bar, GM drum notes) */
const GM = { Kick: 36, Snare: 38, Ghost: 38, Hat: 42, 'Cymbals': 46 };   // a ghost is a quiet 38, the velocity says so
const vlq = n => { const b = [n & 127]; while (n >>= 7) b.unshift((n & 127) | 128); return b; };
const str = t => [...t].map(c => c.charCodeAt(0));
function saveMidi() {
  const TPQ = 96, SIX = TPQ / 4, ev = [], sec = 60 / S.bpm / 4;           // 16 steps = one bar of sixteenths
  ROWS.forEach(r => S.drums[r].mute || S.drums[r].steps.forEach((v, i) => { if (!v) return;
    const note = GM[r], vel = Math.max(1, Math.min(127, Math.round(30 + v * 97)));
    const t = Math.round(i * SIX + feel(r, i, sec) / sec * SIX);           // the shuffle goes in the file
    ev.push([t, 0, [0x99, note, vel]], [t + SIX - 4, 1, [0x89, note, 0]]); }));
  ev.sort((a, b) => a[0] - b[0] || a[1] - b[1]);
  const us = Math.round(6e7 / S.bpm);
  let trk = [0, 0xFF, 0x51, 3, (us >> 16) & 255, (us >> 8) & 255, us & 255];
  let last = 0; ev.forEach(([t, , b]) => { trk = trk.concat(vlq(t - last), b); last = t; });
  trk = trk.concat(vlq(Math.max(16 * SIX, last) - last), [0xFF, 0x2F, 0]);
  const len = trk.length, head = str('MThd').concat([0, 0, 0, 6, 0, 0, 0, 1, 0, TPQ], str('MTrk'),
    [(len >> 24) & 255, (len >> 16) & 255, (len >> 8) & 255, len & 255]);
  const name = `monty-beat-lab-${S.bpm}-${(S.style >= 0 ? STYLES[S.style][0] : 'custom').toLowerCase().replace(/\W+/g, '-')}.mid`;
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([new Uint8Array(head.concat(trk))], { type: 'audio/midi' }));
  a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  spin('#midi');
}


/* ================================================================ first view: build it in front of them */
function run() {
  const lab = R, h1 = $('.hd h1'), word = 'BEAT LAB';
  lab.classList.add('boot');
  const scan = document.createElement('div'); scan.className = 'scan';
  lab.appendChild(scan); setTimeout(() => scan.remove(), 1800);
  let i = 0;                                                    // type the name, cursor and all
  h1.innerHTML = '<span class="cur">_</span>';
  const type = () => { i++;
    h1.innerHTML = word.slice(0, i).replace('BEAT ', 'BEAT <b>').concat(i > 5 ? '</b>' : '') + (i < word.length ? '<span class="cur">_</span>' : '');
    if (i < word.length) setTimeout(type, 55); };
  setTimeout(type, 180);
  setTimeout(() => lab.classList.remove('boot'), 2400);
}
let built = false;
function build() {
  seen = true; if (built) return; built = true;
  if (!matchMedia('(prefers-reduced-motion:reduce)').matches) run();
}

/* ================================================================ start: one pack first, the rest behind it */
let packsLoaded = 0;
// NOT load(): that is the sample loader's name, and shadowing it silently killed every sound
async function loadPacks() {
  if (loaded) return; loaded = true; boot(); requestAnimationFrame(ribbons);
  await loadIdx(FIRST); addPack(FIRST); packsLoaded = 1;
  applyRoll(roll()); setStyle(0); hist = [snapshot()]; hi = 0; marks();
  Promise.all(ROWS.map(r => load(SND[S.drums[r].id])).concat(LOOPS.map(l => load(S.loops[l].s)))).then(() => { const r = $('#ready'); if (r) r.textContent = '[ Ready, sound on ]'; });
  await Promise.all(MONTHS.filter(m => m !== FIRST).map(m => loadIdx(m).then(() => { addPack(m); packsLoaded++; })));
  ROWS.forEach(r => { if (!S.drums[r].id) { const s = pick(pool(r)); if (s) { S.drums[r].id = s.id; load(s); } } });   // the first pack may have no single hats
  LOOPS.forEach(l => { if (!S.loops[l].s) pickLoop(l); });   // the first pack alone may not have had one at this tempo
  prepareNext(); ROWS.concat(LOOPS).forEach(prepareOne); draw();
  if (hist.length <= 1) { hist = [snapshot()]; hi = 0; marks(); }   // the rest of the packs landed and nothing was touched yet: that is the start
}
let loaded = false;
window.MB_BEATLAB = { load: loadPacks, build, stop: () => { if (playing) toggle(); } };
})();
